@for(template of templates; track template.id) {
<et-atoms-templates-search-list-item
  [template]="template"
  (click)="onSelect(template)"
></et-atoms-templates-search-list-item>
}

<!-- Loader -->
@if (loading) {
<div class="flex justify-center py-2">
  <et-atoms-spinner size="small"></et-atoms-spinner>
</div>
}
